import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { tryProcessVideo } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

import { DotCmsFacade } from '../../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../../models/dot-cms-content-types-component.model';

@Component({
  selector: 'custom-dot-cms-vimeo-video',
  templateUrl: './dot-cms-vimeo-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-vimeo-video.component.scss'],
  standalone: false,
})
export class DotCmsVimeoVideoComponent implements DotCmsContentTypeComponent, OnChanges {
  readonly identifier = input<string>(undefined);
  contentlet$: Observable<CustomDotCmsContentlet>;

  constructor(private sanitizer: DomSanitizer, private dotCmsFacade: DotCmsFacade) {}

  ngOnChanges(): void {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier());
  }

  getVideoHeight$(contentlet: CustomDotCmsContentlet): Observable<string> {
    return this.dotCmsFacade.getVideoHeight(contentlet);
  }

  iframeVideoUrl(contentlet: CustomDotCmsContentlet) {
    return tryProcessVideo(contentlet, this.sanitizer);
  }
  getVideoClasses(contentlet: CustomDotCmsContentlet) {
    return this.dotCmsFacade.getVideoClasses(contentlet);
  }
}
